import {
  ARTICLE_SALE_STATUS_CANCELLED,
  ARTICLE_SALE_STATUS_OPEN,
  ARTICLE_SALE_STATUS_PAID
} from "../constants/articleSaleStatus";

/** Beträge unter einem halben Cent gelten als beglichen (Rundungstoleranz). */
const MONEY_EPSILON = 0.005;

export type ArticleSaleDisplayStatus = "open" | "partiallyPaid" | "paid" | "cancelled" | "submitted" | "unknown";

/**
 * Der Artikelverkauf bleibt fachlich offen, solange die Lastschrift nur eingereicht
 * und noch nicht verbucht ist. Für die Anzeige wird dieser Zwischenzustand dennoch
 * ausdrücklich kenntlich gemacht.
 */
export function resolveArticleSaleDisplayStatus(
  status: number,
  submittedSepaDirectDebitRunId?: string | null,
  paidAmount = 0,
  openAmount = 0
): ArticleSaleDisplayStatus {
  if (status === ARTICLE_SALE_STATUS_CANCELLED) return "cancelled";
  if (paidAmount > MONEY_EPSILON && openAmount > MONEY_EPSILON) return "partiallyPaid";
  if (status === ARTICLE_SALE_STATUS_PAID || (paidAmount > MONEY_EPSILON && openAmount <= MONEY_EPSILON)) return "paid";
  if (status === ARTICLE_SALE_STATUS_OPEN && Boolean(submittedSepaDirectDebitRunId)) return "submitted";
  if (status === ARTICLE_SALE_STATUS_OPEN) return "open";
  return "unknown";
}
